var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"juhe-item"},[_c('div',{staticClass:"li-wrap"},[_c('router-link',{attrs:{"to":_vm.link}},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm.time))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }